import * as React from "react";
import { useState } from "react";
import Layout from "../layouts/Layout";

const Datenschutz = () => {
  const pageContext = { pagePath: "/datenschutz" };

  // State für Akkordeons
  const [openIndex, setOpenIndex] = useState(null);
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const rights = [
    {
      title: "Art. 15 DSGVO – Auskunftsrecht",
      content:
        "Sie können jederzeit erfahren, welche personenbezogenen Daten wir über Sie speichern.",
    },
    {
      title: "Art. 16 DSGVO – Recht auf Berichtigung",
      content:
        "Sie können die Korrektur Ihrer Daten verlangen, falls diese nicht korrekt sein sollten.",
    },
    {
      title: "Art. 17 DSGVO – Recht auf Löschung",
      content:
        "Sie können die Löschung Ihrer personenbezogenen Daten verlangen, soweit keine gesetzliche Aufbewahrungspflicht besteht.",
    },
    {
      title: "Art. 18 DSGVO – Einschränkung der Verarbeitung",
      content:
        "Sie können eine zeitweilige Einschränkung der Nutzung Ihrer Daten verlangen.",
    },
    {
      title: "Art. 20 DSGVO – Recht auf Datenübertragbarkeit",
      content:
        "Sie können Ihre Daten in einem strukturierten, maschinenlesbaren Format erhalten oder an einen anderen Anbieter übermitteln lassen.",
    },
    {
      title: "Art. 21 DSGVO – Widerspruchsrecht",
      content:
        "Sie können der Verarbeitung Ihrer Daten widersprechen, soweit keine gesetzlichen Verpflichtungen entgegenstehen.",
    },
    {
      title: "Art. 34 & 77 DSGVO – Sicherheitsverletzungen & Beschwerde",
      content:
        "Wir informieren Sie unverzüglich über Datenschutzverletzungen. Sie haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren.",
    },
  ];

  return (
    <Layout pageContext={pageContext}>
      <div className="container">
        <div className="text-lg max-w-screen-lg 2xl:max-w-screen-xl mx-auto 2xl:mx-0 leading-relaxed">
          <h1 className="text-5xl py-8 mt-6 font-medium">Datenschutz</h1>
          <p className="mb-6 text-gray-700">
            Die <span className="font-semibold">SOL-VE GmbH</span> arbeitet nach
            dem Prinzip der Datensparsamkeit und verzichtet daher vollständig
            auf die Erhebung personenbezogener Informationen wie Namen, Adressen
            oder identifizierbare IP-Daten. Ihre Rechte nach DSGVO bestehen
            selbstverständlich dennoch und werden nachfolgend transparent
            erläutert.
          </p>

          <div className="space-y-4">
            {rights.map((item, index) => {
              const isOpen = openIndex === index;

              return (
                <div
                  key={index}
                  className={`bg-white shadow-md rounded-lg border-l-4 transition-colors duration-500 ${
                    isOpen ? "border-blue-500" : "border-gray-200"
                  }`}
                >
                  <button
                    className="w-full text-left p-4 font-semibold text-lg"
                    onClick={() => toggleAccordion(index)}
                  >
                    {item.title}
                  </button>

                  {isOpen && (
                    <div className="p-4 text-gray-700 border-t border-gray-200 transition-all duration-300">
                      {item.content}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Datenschutz;
